<sf-page-title
    title="Posts"
    icon="clipboard-list"
    description="The main section displays posts — items in Surefire that require action or clearing. These can include engineer certificates, Surequote quotes, or new appointment requests. You can either process a post (which may prompt additional options, such as sending a certificate to a customer or updating an LGSC expiry date) or delete it."
    docUrl="https://surefire-software.gitbook.io/docs/">
</sf-page-title>
<sf-post-search [isCollapsed]="true"></sf-post-search>
<sf-card>
    @if (postsStore.newPostReceivedCounter() > 0) {
        <div class="text-light bg-danger p-2 text-center mb-3">
            <p class="mb-0 fw-bold">
                You have received {{ postsStore.newPostReceivedCounter() }} posts!
                <button
                    sfButton
                    type="button"
                    color="light"
                    size="sm"
                    icon="refresh"
                    class="ms-3"
                    (click)="reloadPosts()">
                    Reload
                </button>
            </p>
        </div>
    }
    <div class="d-flex flex-column flex-md-row mb-2 align-items-md-center">
        <div>
            <button sfButton icon="clipboard" size="sm" (click)="toggleUrgentPosts(false)">
                {{ appStore.postCounter().postsToProcessCount }} Posts
            </button>
            <button sfButton icon="exclamation-circle" color="danger" size="sm" (click)="toggleUrgentPosts(true)">
                {{ appStore.postCounter().urgentPostsToProcessCount }} Urgent Posts
            </button>
            <button sfButton icon="exclamation-circle" color="warning" size="sm" (click)="toggleUnassignedPosts()">
                {{ appStore.postCounter().unassignedPostsToProcessCount }} Unassigned
            </button>
        </div>
        <div class="ms-md-auto" #scrollTo>
            <div class="d-grid d-md-inline-flex g-2 gap-1">
                <button sfButton color="secondary" size="sm" icon="eye" (click)="toggleAdvanced()">Switch view</button>
                @if (postsStore.filter().inChargeStaffId !== appStore.me()?.id) {
                    <button
                        sfButton
                        color="secondary"
                        size="sm"
                        icon="user-check"
                        tooltip="Only show posts assigned to me"
                        (click)="onlyMine()">
                        Assigned to me
                    </button>
                } @else {
                    <button
                        sfButton
                        color="secondary"
                        size="sm"
                        icon="user-check"
                        tooltip="Only show assigned and unassigned posts"
                        (click)="showAssignedAndUnassigned()">
                        All Posts
                    </button>
                }

                <button
                    sfButton
                    color="secondary"
                    size="sm"
                    icon="refresh"
                    tooltip="Reload the the posts"
                    (click)="reloadPosts()">
                    Reload

                    @if (postsStore.newPostReceivedCounter() > 0) {
                        <span class="badge text-bg-danger">{{ postsStore.newPostReceivedCounter() }}</span>
                    }
                </button>
            </div>
        </div>
    </div>

    @if (postsStore.postsPaged(); as postsPaged) {
        @if (postsPaged.items.length) {
            @if (!postsStore.advanced()) {
                <div class="d-none d-xl-block">
                    <div class="row align-items-center bg-light border-top border-bottom border-dark-subtle py-2">
                        <div class="col-1 small fw-semibold text-primary text-uppercase">Warnings</div>
                        <div class="col-1 small fw-semibold text-primary text-uppercase">Appointment Type</div>
                        <div class="col-2 small fw-semibold text-primary text-uppercase">Post Type</div>
                        <div class="col-2 small fw-semibold text-primary text-uppercase">Address</div>
                        <div class="col-1 small fw-semibold text-primary text-uppercase">Engineer</div>
                        <div class="col-2 small fw-semibold text-primary text-uppercase">Assigned to</div>
                        <div class="col-1 small fw-semibold text-primary text-uppercase">Received</div>
                        <div class="col-2"></div>
                    </div>
                </div>
            }
            @for (post of postsStore.entities(); track post.id) {
                <sf-post-detail
                    [post]="post"
                    [staff]="staff()"
                    (onPostClick)="onPostClick($event)"
                    (onViewCertificate)="viewCertificate($event)"></sf-post-detail>
            }
            <sf-pagination-detail
                [paginationData]="postsPaged"
                [scrollToElement]="scrollTo"
                (onPageChange)="pageChanged($event)">
            </sf-pagination-detail>
        }

        @if (postsPaged.totalItemCount === 0) {
            <sf-empty message="There are no posts, amend your search criteria and search again"></sf-empty>
        }
    }
</sf-card>
